// Notability-flag display metadata (slice 3). Keys mirror backend FlagKeys.All.
// Labels here are the SHORT badge forms; the API's ContactAnalyticsFlag.label
// carries the full label and .explanation the plain-language sentence.

export const FLAG_KEYS = [
  'cross_district',
  'mixed_party_household',
  'mega_household',
  'sleeping_giant',
  'volunteer_prospect',
  'ballot_drop_risk',
  'steward_reach',
  'new_arrival',
  'primary_only_leverage',
] as const

export const FLAG_BADGES: Record<string, { label: string; colorScheme: string }> = {
  cross_district: { label: 'Cross-district', colorScheme: 'purple' },
  mixed_party_household: { label: 'Mixed-party HH', colorScheme: 'orange' },
  mega_household: { label: 'Mega-household', colorScheme: 'cyan' },
  sleeping_giant: { label: 'Sleeping giant', colorScheme: 'blue' },
  volunteer_prospect: { label: 'Volunteer prospect', colorScheme: 'green' },
  ballot_drop_risk: { label: 'Ballot-drop risk', colorScheme: 'red' },
  steward_reach: { label: 'Steward reach', colorScheme: 'teal' },
  new_arrival: { label: 'New arrival', colorScheme: 'yellow' },
  primary_only_leverage: { label: 'Primary-only', colorScheme: 'pink' },
}

export function flagLabel(key: string): string {
  return FLAG_BADGES[key]?.label ?? key
}

// Tooltip copy — VERBATIM mirror of backend FlagExplanations.GenericDescription.
// If you change one, change both (backend test guards the canonical strings).
export const FLAG_DESCRIPTIONS: Record<string, string> = {
  cross_district: 'Works in a competitive district outside their home district',
  mixed_party_household: 'Household has registered voters from both parties',
  mega_household: 'Large multi-voter household',
  sleeping_giant: 'Strongly aligned and civically engaged, but unlikely to vote',
  volunteer_prospect: 'Highly engaged reliable voter in a competitive district',
  ballot_drop_risk: 'Consistent voter whose registration is no longer active',
  steward_reach: 'Union steward with wide member reach',
  new_arrival: 'Recently registered or switched parties in a competitive district',
  primary_only_leverage: 'Likely primary voter in a safe district — the primary is the election',
}
